import React from "react"

interface LinkCircleIconProps {
  color?: string;
}

const LinkCircleIcon: React.FC<LinkCircleIconProps> = ({
  color = "currentColor",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9C9 9 7 9.6 7 12C7 14.4 9 15 10 15M14 9C15 9 17 9.6 17 12C17 14.4 15 15 14 15M10 12H14"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LinkCircleIcon
